import { Component } from '@angular/core';
import { FansService } from '@services';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { ToastrService } from 'ngx-toastr';
import { environment } from '@env/environment';
import { Router } from '@angular/router';
@Component({
  selector: 'app-download-cell-render',
  templateUrl: './download-cell-render.component.html',
  styleUrls: ['./download-cell-render.component.scss'],
})
export class DownloadCellRenderComponent implements ICellRendererAngularComp {
  constructor(
    private fanService: FansService,
    private _toast: ToastrService,
    private router: Router,
  ) {
    this.environment = environment;
  }
  public displayValue: any;
  isLoading: boolean = false;
  environment: any;
  link!: string;
  isDownload = true;
  isPresigned = false;
  agInit(params: ICellRendererParams): void {
    this.displayValue = params;
    this.link = params.value;
    const isDownload = this.displayValue.isDownload;
    this.isPresigned = this.displayValue.isPresigned ?? false;
    if (typeof isDownload === 'boolean') this.isDownload = isDownload;
  }

  refresh(params: ICellRendererParams): boolean {
    return false;
  }
  onActionClick(actionType: string, link: string) {
    this.displayValue.clicked(actionType, link);
  }
}
